<template>
    <div>
        <v-row>
            <v-col md="12">
                <v-stepper v-model="step" @reload="reloadstep($event)" non-linear>
                    <v-stepper-header>
                        <v-stepper-step
                            :complete="step > 1"
                            color="primary"
                            step="1" 
                        >{{ $t("workers.register.title_step_1") }}</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step
                            :complete="step > 2"
                            color="primary"
                            step="2" 
                        >{{ $t("workers.register.title_step_2_optional") }}</v-stepper-step>
                        <v-divider ></v-divider>
                        <v-stepper-step
                            :complete="step > 3"
                            color="primary"
                            step="3" 
                        >{{ $t("workers.register.title_step_3") }}</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step
                            :complete="step > 4"
                            color="primary"
                            step="4" 
                        >{{ $t("workers.register.title_step_4") }}</v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items class="st_items">
                        <v-stepper-content step="1">
                            <v-container>
                                <v-form ref="informationForm" @submit.prevent="goAddressStep">
                                    <v-row>
                                        <v-col md="6" class="text-left">
                                            <v-btn
                                                @click="previusBtn"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.back")}}</v-btn>
                                        </v-col>
                                        <v-col md="6" class="text-right">
                                            <v-btn
                                                type="submit"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.next")}}</v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" class="py-1 text-left">
                                            <p>{{ $t("workers.register.subtitle_step_1") }}</p>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field v-model="informationForm.firstname" :rules="rules.firstname"  outlined append-icon="fas fa-user" dense :label="$t('common.form.first-name')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field v-model="informationForm.lastname" :rules="rules.lastname"  append-icon="fas fa-user" outlined dense :label="$t('common.form.last-name')"></v-text-field>
                                        </v-col>
                                        <v-col v-if="$route.path != '/SpectatorsCreate' " cols="12" md="6" class="py-1">
                                            <v-text-field v-model="informationForm.phone" :rules="rules.phone" append-icon="fas fa-phone-alt"  outlined dense :label="$t('common.form.phone')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-menu
                                                ref="menu"
                                                v-model="menu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="informationForm.birthdate" :rules="rules.birthdate"
                                                        :label="$t('common.form.birthdate')"
                                                        outlined dense
                                                        append-icon="far fa-calendar-alt"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        hint="yyyy-mm-dd"
                                                        persistent-hint    
                                                        readonly
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker 
                                                    :max="max_date" 
                                                    :min="min_date" 
                                                    ref="picker" 
                                                    v-model="informationForm.birthdate" 
                                                    @input="menu = false"
                                                    :header-date-format="$datePicker.formatDateHeader"
                                                    :title-date-format="$datePicker.formatTitleDate"
                                                    :weekday-format="$datePicker.formatWeekday"
                                                    :month-format="$datePicker.formatMonth"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-select 
                                                v-model="informationForm.gender" 
                                                item-value="id" 
                                                item-text="value" 
                                                :items="genderItems" 
                                                :rules="rules.gender" 
                                                outlined 
                                                dense 
                                                append-icon="fas fa-venus-mars" 
                                                :label="$t('common.gender')"
                                                :no-data-text="$t('common.no_data')"
                                            ></v-select>
                                        </v-col>                                        
                                    </v-row>
                                    <v-row>
                                        <v-col md="6" class="text-left">
                                            <v-btn
                                                @click="previusBtn"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.back")}}</v-btn>
                                        </v-col>
                                        <v-col md="6" class="text-right">
                                            <v-btn
                                                type="submit"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.next")}}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <v-container>
                                <v-form ref="informationLogin" @submit.prevent="goEmailStep">
                                    <v-row>
                                        <v-col md="6" class="text-left">
                                            <v-btn
                                                @click="step=1"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.back")}}</v-btn>
                                        </v-col>
                                        <v-col md="6" class="text-right">
                                            <v-btn
                                                type="submit"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.next")}}</v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col v-if="$route.path != '/SpectatorsCreate' "  cols="12" class="py-1 text-center">
                                            <p>{{ $t("workers.register.subtitle_step_2_optional_1") }}<br />
                                                {{ $t("workers.register.subtitle_step_2_optional_2") }}</p>
                                        </v-col>
                                        <v-col v-else cols="12" class="py-1 text-center">
                                            <p>{{ $t("workers.register.subtitle_step_2_optional_3") }}<br />
                                                {{ $t("workers.register.subtitle_step_2_optional_4") }}</p>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-row>
                                                <v-col cols="12" class="pb-0">
                                                    <v-text-field type="email" v-model="informationLogin.email" :rules="rules.email_login"  outlined append-icon="fas fa-envelope" dense :label="$t('common.form.email')"></v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-text-field type="email" v-model="informationLogin.confirmEmail" :rules="rules.ver_email_login"  append-icon="fas fa-check" outlined dense :label="$t('common.form.confirm-email')"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col v-if="$route.path != '/SpectatorsCreate' " cols="12" md="6" class="py-1">
                                            <v-row>
                                                <v-col cols="12" class="pb-0">
                                                    <v-text-field type="password" v-model="informationLogin.password" :rules="rules.password_login" append-icon="fas fa-lock"  outlined dense :label="$t('common.form.password')"></v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-text-field type="password" v-model="informationLogin.confirmPassword" :rules="rules.ver_password_login" append-icon="fas fa-check"  outlined dense :label="$t('common.form.confirm-password')"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>                                      
                                    </v-row>
                                    <v-row>
                                        <v-col md="6" class="text-left">
                                            <v-btn
                                                @click="step=1"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.back")}}</v-btn>
                                        </v-col>
                                        <v-col md="6" class="text-right">
                                            <v-btn
                                                type="submit"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.next")}}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                            <v-container>
                                <v-form ref="addressForm" @submit.prevent="goEmergencyContact">
                                    <v-row>
                                        <v-col md="6" class="text-left">
                                            <v-btn
                                                @click="step--"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.back")}}</v-btn>
                                        </v-col>
                                        <v-col md="6" class="text-right">
                                            <v-btn
                                                type="submit"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.next")}}</v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col md="12" class="text-right py-1">
                                            <v-checkbox
                                                v-model="chk_address"
                                                @change="getAddress"
                                                :label="$t('common.form.copy_address')"
                                                ></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field  v-model="addressForm.address" :rules="rules.address" append-icon="far fa-id-card" outlined dense :label="$t('common.form.address')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-select  
                                                :items="countryItems" 
                                                :rules="rules.country" 
                                                v-model="addressForm.country"  
                                                append-icon="fas fa-globe-americas" 
                                                outlined dense 
                                                :label="$t('common.form.country')"
                                                :no-data-text="$t('common.no_data')"
                                                @change="getStatesByCountry"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-select  
                                                :items="stateItems" 
                                                :rules="rules.state" 
                                                v-model="addressForm.state" 
                                                append-icon="far fa-flag" 
                                                outlined 
                                                dense 
                                                :label="$t('common.form.state')"
                                                :no-data-text="$t('common.no_data')"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field v-model="addressForm.city" :rules="rules.city"  append-icon="fas fa-city" outlined dense :label="$t('common.form.city')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field v-model="addressForm.zip" :rules="rules.zip"  append-icon="far fa-id-card" outlined dense :label="$t('common.form.zip')"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col md="6" class="text-left">
                                            <v-btn
                                                @click="step--"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.back")}}</v-btn>
                                        </v-col>
                                        <v-col md="6" class="text-right">
                                            <v-btn
                                                type="submit"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.next")}}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-stepper-content>
                        <v-stepper-content step="4">
                            <v-container>
                                <v-form ref="emergencyForm" @submit.prevent="createPart">
                                    <v-row>
                                        <v-col md="6" class="text-left">
                                            <v-btn
                                                @click="step--"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.back")}}</v-btn>
                                        </v-col>
                                        <v-col md="6" class="text-right">
                                            <v-btn
                                                type="submit"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.next") }}</v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col md="12" class="text-right py-1">
                                            <v-checkbox
                                                v-model="chk_emergencyContact"
                                                @change="getEmergencyContact"
                                                :label="$t('workers.register.copy_emergency_contact')"
                                                ></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field append-icon="fas fa-user" v-model="emergencyForm.firstname" :rules="rules.firstname"  outlined dense :label="$t('common.form.first-name')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field append-icon="fas fa-user" v-model="emergencyForm.lastname" :rules="rules.lastname"  outlined dense :label="$t('common.form.last-name')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field append-icon="fas fa-phone-alt" v-model="emergencyForm.phone" :rules="rulesPhoneNumber"  outlined dense :label="$t('common.form.phone')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field  append-icon="fas fa-phone-alt" v-model="emergencyForm.cell" :rules="rulesCellNumber"  outlined dense :label="$t('common.form.cell')"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-1">
                                            <v-text-field  append-icon="fas fa-envelope" v-model="emergencyForm.email" :rules="rules.email_emergency"  outlined dense :label="$t('common.form.email')"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col md="6" class="text-left">
                                            <v-btn
                                                @click="step--"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.back")}}</v-btn>
                                        </v-col>
                                        <v-col md="6" class="text-right">
                                            <v-btn
                                                type="submit"
                                                class="btn_back"
                                                color="primary"
                                            >{{ $t("common.next") }}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from "vuex";

const informationForm = Object.freeze({ firstname: "", lastname: "", phone: "", birthdate: null, gender: "" });
const informationLogin = Object.freeze({ email: "", password: "", confirmEmail: "", confirmPassword: "" });
const addressForm = Object.freeze({ address: "", country: "", state: "", city: "", zip: "" });
const emergencyForm = Object.freeze({ firstname: "", lastname: "", phone: "", cell: "", email: "" });

const patternPhone = /^[0-9-]{10,12}$/;        
const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
    mixins: [apiCalls],
    name: "Register",
    data() {
        return {
            step: 1,
            informationForm: Object.assign({}, informationForm),
            informationLogin: Object.assign({}, informationLogin),
            addressForm: Object.assign({}, addressForm),
            emergencyForm: Object.assign({}, emergencyForm),
            menu: false,
            chk_address: false,
            countryItems: [],
            stateItems: [],
            chk_emergencyContact: false,
            buttonColor: ''
        };
    },
    computed: {
        rules() {
            return {
                address: [ 
                    val => (val || "").length > 0 || this.$t("workers.register.address_required"),
                    val => ((val || "").length > 3 && (val || "").length < 100) || this.$t("workers.register.length_address")
                ],
                country:[
                    val => (val || "").length > 0 || this.$t("workers.register.country_required")
                ],
                state: [
                    val => (val || "").length > 0 || this.$t("workers.register.state_required")
                ],
                city:[
                    val => (val || "").length > 0 || this.$t("workers.register.city_required")
                ],
                zip:[
                    val => (val || "").length > 0 || this.$t("workers.register.zip_required")
                ],
                firstname: [ 
                    val => (val || "").length > 0 || this.$t("workers.register.firstname_required"),
                    val => ((val || "").length > 1 && (val || "").length < 100) || this.$t("workers.register.length_firstname")
                ],
                lastname: [ 
                    val => (val || "").length > 0 || this.$t("workers.register.lastname_required"),
                    val => ((val || "").length > 2 && (val || "").length < 100) || this.$t("workers.register.length_lastname")
                ],
                email_emergency: [ 
                    val => (val || "").length > 0 || this.$t("workers.register.email_required"),
                    val => pattern.test(val) || this.$t("workers.register.email_invalid")
                ],
                email: [ 
                    val => {
                        if((val || "").length > 0)
                            return pattern.test(val) || this.$t("workers.register.email_invalid")

                        return true;
                    }
                ],
                phone:[
                    val => (val || "").length > 0 || this.$t("workers.register.phone_required"),
                    val => {
                        let vm = this, response
                        if((val || "").length > 0)
                           response = !!val.match(patternPhone) 
                        

                        if((val || "").match(/^[0-9-]{3,12}$/)){
                            vm.informationForm.phone=vm.informationForm.phone.replaceAll("-", "")
                            const lengthPhone = vm.informationForm.phone.length
                            
                            if(lengthPhone>=4 && lengthPhone<7){
                                vm.informationForm.phone=vm.informationForm.phone.substring(0, 3)+"-"+vm.informationForm.phone.substring(3)
                                
                            }

                            if(lengthPhone>=7){
                            vm.informationForm.phone=vm.informationForm.phone.replaceAll("-", "")
                            vm.informationForm.phone=vm.informationForm.phone.substring(0, 3)+"-"+vm.informationForm.phone.substring(3, 6) +"-"+vm.informationForm.phone.substring(6)
                            }
                            if(lengthPhone<10){
                                return this.$t("workers.register.phone_invalid")
                            }else if(lengthPhone>10){
                                return this.$t("workers.register.phone_invalid")
                            }else{
                                vm.informationForm.phone=vm.informationForm.phone.replaceAll("-", "")
                                vm.informationForm.phone=vm.informationForm.phone.substring(0, 3) +"-"+vm.informationForm.phone.substring(3, 6) +"-"+vm.informationForm.phone.substring(6, 10)
                            } 
                        }
                        if(!response)
                            return this.$t("workers.register.phone_invalid")

                        return true;
                    }
                ],
                phone_emergency: [ 
                    val => (val || "").length > 0 || this.$t("workers.register.email_required"),
                    val => val.match(patternPhone) || this.$t("workers.register.phone_invalid")
                ],
                gender: [ 
                    val => (val || "").length > 0 || this.$t("workers.register.gender_required")
                ],
                birthdate: [ 
                    val => (val || "").length > 0 || this.$t("workers.register.birthdate_required"),
                    val => {
                        const arrayDate = (val || "").toString().split("-");
                        const birthdate = new Date(arrayDate[0], parseInt(arrayDate[1] - 1), arrayDate[2]);
                        const _now = new Date();
                        const agoYear1 = new Date(_now.getFullYear() - 1, _now.getMonth(), _now.getDate());
                        return birthdate <= agoYear1 || this.$t("workers.register.birthdate_invalid")
                    }
                ],
                password: [ 
                    val =>{
                        if(val.length > 0)
                            return ((val || "").length > 3 && (val || "").length < 50) || this.$t("workers.register.length_password")
                        return true;
                    }
                ],
                ver_password:[
                    val =>{
                        if(this.password == val)
                            return (this.password == val) || this.$t("workers.register.password_equals")
                        return true;
                    }
                ],
                email_login: [ 
                    val => (val || "").length > 0 || this.$t("workers.register.email_required"),
                    val => {
                        if((val || "").length > 0) {
                            if(pattern.test(val)){
                                this.informationLogin.email = this.informationLogin.email.toLowerCase();
                                
                            }else{
                                return this.$t("workers.register.email_invalid")
                            }
                           
                        }
                        return true;
                    }
                ],
                password_login: [ 
                    val => (val || "").length > 0 || this.$t("workers.register.password_required"),
                    val =>{
                        if((val || "").length > 0)
                            return ((val || "").length > 3 && (val || "").length < 50) || this.$t("workers.register.length_password")
                        return true;
                    }
                ],
                ver_password_login:[
                    val =>{
                        if((this.informationLogin.password || "").length > 0)
                            return (this.informationLogin.password == val) || this.$t("workers.register.password_equals")
                        return true;
                    }
                ],
                ver_email_login: [
                    val => {
                        if((val || "").length > 0) {
                            if(pattern.test(val)){
                                this.informationLogin.confirmEmail = this.informationLogin.confirmEmail.toLowerCase();
                                
                            }else{
                                return this.$t("workers.register.email_invalid")
                            }
                           
                        }
                        if((this.informationLogin.email || "").length > 0)
                            return (this.informationLogin.email == val) || this.$t("workers.register.email_equals")
                        return true;
                    }
                ]
            }; 
        },
        genderItems() {
            return [
                {id: '', value: this.$t("common.form.select_gender") },
                {id: 'male', value: this.$t("common.form.male") },
                {id: 'female', value: this.$t("common.form.female")}
            ];
        },
        max_date(){
            const _now = new Date();
            const maxDateString = [_now.getFullYear() - 1, _now.getMonth(), _now.getDate()].join('-');
            return maxDateString;
        },
        min_date(){
            const _now = new Date();
            const minDateString = [_now.getFullYear() - 124, _now.getMonth(), _now.getDate()].join('-');
            return minDateString;
        },
        rulesPhoneNumber() {
            return [
                (val) => (val || "").length > 0 || this.$t("workers.register.phone_required"),
                (val) => {

                        let vm = this, response
                        if((val || "").length > 0)
                           response = !!val.match(/^[0-9-]{10,12}$/)
                        

                        if((val || "").match(/^[0-9-]{3,12}$/)){
                            vm.emergencyForm.phone=vm.emergencyForm.phone.replaceAll("-", "")
                            const lengthPhone = vm.emergencyForm.phone.length
                            
                            if(lengthPhone>=4 && lengthPhone<7){
                                vm.emergencyForm.phone=vm.emergencyForm.phone.substring(0, 3)+"-"+vm.emergencyForm.phone.substring(3)
                                
                            }

                            if(lengthPhone>=7){
                            vm.emergencyForm.phone=vm.emergencyForm.phone.replaceAll("-", "")
                            vm.emergencyForm.phone=vm.emergencyForm.phone.substring(0, 3)+"-"+vm.emergencyForm.phone.substring(3, 6) +"-"+vm.emergencyForm.phone.substring(6)
                            }
                            if(lengthPhone<10){
                                return this.$t("workers.register.phone_invalid")
                            }else if(lengthPhone>10){
                                return this.$t("workers.register.phone_invalid")
                            }else{
                                vm.emergencyForm.phone=vm.emergencyForm.phone.replaceAll("-", "")
                                vm.emergencyForm.phone=vm.emergencyForm.phone.substring(0, 3) +"-"+vm.emergencyForm.phone.substring(3, 6) +"-"+vm.emergencyForm.phone.substring(6, 10)
                            } 
                        }
                        if(!response)
                            return this.$t("workers.register.phone_invalid")

                        return true;
                }
            ];
        },
        rulesCellNumber() {
            return [
                (val) => (val || "").length > 0 || this.$t("workers.register.cell_number_required"),
                (val) => {

                        let vm = this, response
                        if((val || "").length > 0)
                           response = !!val.match(/^[0-9-]{10,12}$/)
                        

                        if((val || "").match(/^[0-9-]{3,12}$/)){
                            vm.emergencyForm.cell=vm.emergencyForm.cell.replaceAll("-", "")
                            const lengthPhone = vm.emergencyForm.cell.length
                            
                            if(lengthPhone>=4 && lengthPhone<7){
                                vm.emergencyForm.cell=vm.emergencyForm.cell.substring(0, 3)+"-"+vm.emergencyForm.cell.substring(3)
                                
                            }

                            if(lengthPhone>=7){
                            vm.emergencyForm.cell=vm.emergencyForm.cell.replaceAll("-", "")
                            vm.emergencyForm.cell=vm.emergencyForm.cell.substring(0, 3)+"-"+vm.emergencyForm.cell.substring(3, 6) +"-"+vm.emergencyForm.cell.substring(6)
                            }
                            if(lengthPhone<10){
                                return this.$t("workers.register.phone_invalid")
                            }else if(lengthPhone>10){
                                return this.$t("workers.register.phone_invalid")
                            }else{
                                vm.emergencyForm.cell=vm.emergencyForm.cell.replaceAll("-", "")
                                vm.emergencyForm.cell=vm.emergencyForm.cell.substring(0, 3) +"-"+vm.emergencyForm.cell.substring(3, 6) +"-"+vm.emergencyForm.cell.substring(6, 10)
                            } 
                        }
                        if(!response)
                            return this.$t("workers.register.phone_invalid")

                        return true;
                }
            ];
        },
        ageValidate18() {
            const arrayDate = (this.informationForm.birthdate || "").toString().split("-");
            if(arrayDate.length > 2) {
                const birthdate = new Date(arrayDate[0], parseInt(arrayDate[1] - 1), arrayDate[2]);
                const _now = new Date();
                const agoYear18 = new Date(_now.getFullYear() - 18, _now.getMonth(), _now.getDate());
                return birthdate <= agoYear18;
            }
            return false;            
        },
        ...mapState({
            user: state => state.session.session.userSession,
            profile: state => state.session.session.profileUserSession
        })
    },
    methods: {
        reloadstep(newStep) {
            this.step = newStep;
        },
        previusBtn() {
            if(this.step > 1) {
                this.step--;
            } else {
                this.$emit('backStep');
            }
        },
        goAddressStep() {
            if(!this.$refs.informationForm.validate()) {
                this.$emit("showError", this.$t("workers.register.validate_step"));
                return
            }
            if(this.informationForm.phone.length == 0 && this.informationForm.cell.length == 0){
                this.$emit("showError", this.$t("workers.register.phone_invalid_empty"));
                return
            }
            if(!this.ageValidate18) {
                this.$emit("showError", this.$t("workers.register.age_minor_invalid"));
                return

            }
            this.step = 2;
        },
        getAddress(){
            if(!this.profile) {
                this.$emit("showError", this.$t("workers.register.profile_not_available"));
            } else if(this.chk_address){
                this.addressForm.country = this.profile.country;
                this.getStatesByCountry();
                this.addressForm.address = this.profile.address;
                this.addressForm.city = this.profile.city;
                this.addressForm.state = this.profile.state;                    
                this.addressForm.zip = this.profile.zip;
            }else{
                this.addressForm.country = '';
                this.addressForm.address = '';
                this.addressForm.city = '';
                this.addressForm.state = '';                    
                this.addressForm.zip = '';
            }
            
        },
        async loadCountries() {
            const resp = await this.getApi('/api/v1/setting/getCountries');
            
            if(Array.isArray(resp) && resp.length > 0) {
                this.countryItems = resp;
            }
        },
        async getStatesByCountry() {
            if(this.addressForm.country) {
                const resp = await this.getApi('/api/v1/setting/getStates/'+this.addressForm.country);
                this.stateItems = Array.isArray(resp) ? resp : [];
            }
        },
        goEmergencyContact() {
            if(!this.$refs.addressForm.validate()) {
                this.$emit("showError", this.$t('workers.register.validate_step'));
                return
            }
            this.step++;
        },
        getEmergencyContact() {
            if(this.chk_emergencyContact){
                this.emergencyForm.firstname = this.profile.firstName;
                this.emergencyForm.lastname = this.profile.lastName;
                this.emergencyForm.phone = this.profile.phone;
                this.emergencyForm.cell = this.profile.phone;
                this.emergencyForm.email = this.profile.emailAddress;
            }else{
                this.emergencyForm.firstname = '';
                this.emergencyForm.lastname = '';
                this.emergencyForm.phone = '';
                this.emergencyForm.cell = '';
                this.emergencyForm.email = '';
            }
        },
        async goEmailStep() {
            if(!this.$refs.informationLogin.validate()) {
                this.$emit("showError", this.$t("workers.register.validate_step"));
                return
            }
            let band = false;
            const response = await this.getApi(`/api/v1/livelaps/user/preventDuplicateEmail/${this.informationLogin.email}`);
            
            if(response && response.match) {
                this.$emit("showError", this.$t(`workers.register.${response.message}`));
                band = true;
            }
            if(band) return;

            this.step = 3;
        },
        async createPart(){
            if(!this.$refs.emergencyForm.validate()) {
                this.$emit("showError", this.$t("workers.register.validate_step"));
                return
            }
            let data = {
                    userId: this.user.id,
                    birthday: this.informationForm.birthdate,
                    firstname: this.informationForm.firstname,
                    gender: this.informationForm.gender,
                    lastname: this.informationForm.lastname,
                    address: this.addressForm.address,
                    city: this.addressForm.city,
                    country: this.addressForm.country,
                    state: this.addressForm.state,
                    zip: this.addressForm.zip,
                    ec_email: this.emergencyForm.email,
                    ec_firstname: this.emergencyForm.firstname,
                    ec_lastname: this.emergencyForm.lastname,
                    ec_phone: this.emergencyForm.phone,
                    ec_cell: this.emergencyForm.cell,
                    email: this.informationLogin.email,
                    password: this.informationLogin.password,
                    type: 'Worker'
            };
            //let idUserCreated = 0;
            if(this.informationForm.phone.length > 0) data.phone = this.informationForm.phone;

            const response = await this.postApi('/api/v1/promoter/relationShip/createAccount',data);
            
            if(!response || (response && response.success == 0)) {
                if(response && (response.message == "duplicate_account" || response.message == "existing_account")) {
                    this.$emit("showErrorOptions", { 
                        msg: this.$t("workers.register.existing_account",{ email: this.informationLogin.email}), 
                        options: { xSmall: true, widthMd: true } 
                    });
                } else {
                    this.$emit("showError", this.$t("workers.register.failed_create_participant"));
                }
            } else {
                localStorage.setItem("create_worker", JSON.stringify(response.message));
                this.$emit("nextStep");
                this.clearForm();
            }
        },
        clearForm() {
            this.step = 1;
            this.$refs.informationForm.reset();
            this.$refs.informationLogin.reset();
            this.$refs.addressForm.reset();
            this.$refs.emergencyForm.reset();
        }
    },
    created() {
        this.buttonColor = process.env.VUE_APP_BUTTON_COLOR;
        this.loadCountries();
        this.$store.dispatch('setProfile');
    },
    watch: {
        ageValidate18() {}
    }
};
</script>

<style scss>

</style>